import React, { PureComponent } from "react";
import { LOCAL_TOGGLE_OVERLAY_MUTATION } from "../../apollo-state/graphql/mutations";
import { Mutation } from "react-apollo";
import Cta from "../cta/cta";

import "./ask-widget.scss";

class AskWidget extends PureComponent {
  render() {
    const { me } = this.props;

    return (
      <div className="ask-widget">
        <div className="ask-widget__content">
          <p>Have a question of your own?</p>
          <Mutation mutation={LOCAL_TOGGLE_OVERLAY_MUTATION}>
            {(signUp) => {
              const ctaProps = {
                text: "Ask the nest",
              };

              if (!me) {
                ctaProps.tag = "button";
                ctaProps.onClick = signUp;
              } else {
                ctaProps.tag = "link";
                ctaProps.link = `/the-nest/ask`;
              }
              return <Cta {...ctaProps} />;
            }}
          </Mutation>
        </div>
      </div>
    );
  }
}

export default AskWidget;
